import { http, HttpResponse } from 'msw';
import { PlessService } from '../../../app/shared/pless-service.model';


export const kymw21Handlers = [

  // 媒体情報取得 /kymw21/getCatalogProgressOfMedium
  http.post(PlessService.SERVICE.getCatalogProgressOfMedium.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(GetCatalogProgressOfMediumResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }),

  // 注文コード /kymw21/getOrderNumList
  http.post(PlessService.SERVICE.getOrderNumList.url,
    async ({ request }) => {
      const req: any = await request.json();
      const mediumType = req.data.parameter.MediumType;
      const pattern = GetCatalogProgressOfMediumResponse.result.obj.find(data => data.MediumType === mediumType)?.OrderNumSettingPattern;
      return HttpResponse.json(GetOrderNumListResponse(pattern));
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }),

  // 一括付番 /kymw21/updateIndiscriminatelyOrderNum
  http.post(PlessService.SERVICE.updateIndiscriminatelyOrderNum.url,
    async ({ request }) => {
      const req: any = await request.json();
      return HttpResponse.json(updateIndiscriminatelyOrderNumResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }),

  // 注文コード設定 /KYMW21/updateIndividuallyOrderNum
  http.post(PlessService.SERVICE.updateIndividuallyOrderNum.url,
    async ({ request }) => {
      const req: any = await request.json();
      return HttpResponse.json(updateIndividuallyOrderNumResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }),
];

const GetCatalogProgressOfMediumResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        "MediumType": "001",
        "MediumName": "ハピデリ",
        "CodeName": "",
        "ProgressWorkNum": "",
        "OrderNumSettingPattern": "01",
      },
      {
        "MediumType": "003",
        "MediumName": "ぐるめぐり",
        "CodeName": "",
        "ProgressWorkNum": "",
        "OrderNumSettingPattern": "01",
      },
      {
        "MediumType": "004",
        "MediumName": "きらきらベビー",
        "CodeName": "",
        "ProgressWorkNum": "",
        "OrderNumSettingPattern": "01",
      },
      {
        "MediumType": "026",
        "MediumName": "eフレンズ専用(EC限定)",
        "CodeName": "",
        "ProgressWorkNum": "",
        "OrderNumSettingPattern": "02",
      },
      {
        "MediumType": "008",
        "MediumName": "IT先着順(在庫限定)",
        "CodeName": "",
        "ProgressWorkNum": "",
        "OrderNumSettingPattern": "02",
      },
      {
        "MediumType": "100",
        "MediumName": "日用ざっか広場",
        "CodeName": "",
        "ProgressWorkNum": "",
        "OrderNumSettingPattern": "03",
      },
      {
        "MediumType": "110",
        "MediumName": "ペットといっしょ",
        "CodeName": "",
        "ProgressWorkNum": "",
        "OrderNumSettingPattern": "03",
      },
      {
        "MediumType": "120",
        "MediumName": "いつでも注文",
        "CodeName": "",
        "ProgressWorkNum": "",
        "OrderNumSettingPattern": "09",
      },
      {
        "MediumType": "130",
        "MediumName": "いきいきくらす",
        "CodeName": "",
        "ProgressWorkNum": "",
        "OrderNumSettingPattern": "09",
      },
      {
        "MediumType": "140",
        "MediumName": "ポイント交換商品",
        "CodeName": "",
        "ProgressWorkNum": "",
        "OrderNumSettingPattern": "07",
      },
      {
        "MediumType": "150",
        "MediumName": "予約チラシ",
        "CodeName": "",
        "ProgressWorkNum": "",
        "OrderNumSettingPattern": "08",
      },
      {
        "MediumType": "160",
        "MediumName": "クーポン",
        "CodeName": "",
        "ProgressWorkNum": "",
        "OrderNumSettingPattern": "04",
      },
      {
        "MediumType": "180",
        "MediumName": "ほぺたんクイズ",
        "CodeName": "",
        "ProgressWorkNum": "",
        "OrderNumSettingPattern": "06",
      },
    ],
  },
};

const GetOrderNumListResponse = (pattern: string) => {
  switch (pattern) {
    case "01":
      return {
        status: 'ok',
        message: '処理完了',
        result: {
          obj: orderNumListPattern01
        }
      };
    case '02':
    case '03':
    case '06':
      return {
        status: 'ok',
        message: '処理完了',
        result: {
          obj: orderNumListPattern02And03And06
        }
      };
    case '04':
      return {
        status: 'ok',
        message: '処理完了',
        result: {
          obj: orderNumListPattern04
        }
      };
    case '07':
    case '09':
      return {
        status: 'ok',
        message: '処理完了',
        result: {
          obj: orderNumListPattern07And09
        }
      };
    case '08':
      return {
        status: 'ok',
        message: '処理完了',
        result: {
          obj: orderNumListPattern08
        }
      };
  }
};

const orderNumListPattern01 = [{
  OrderNum: '111111',
  PCode: 'P1111111',
  GuideGoodsName: '商品1',
  GuideStandardName: '規格1',
  PageNum: '1',
  OrderNumSeqNo: '10',
  Digits: '6',
  CouponGoodsNo: '',
  CouponName: '',
  PreOrderDetailId: ''
}, {
  OrderNum: '222',
  PCode: 'P222222',
  GuideGoodsName: '商品2',
  GuideStandardName: '規格2',
  PageNum: '1',
  OrderNumSeqNo: '20',
  Digits: '3',
  CouponGoodsNo: '',
  CouponName: '',
  PreOrderDetailId: ''
},
{
  OrderNum: '',
  PCode: 'P3333333',
  GuideGoodsName: '商品3',
  GuideStandardName: '規格3',
  PageNum: '1',
  OrderNumSeqNo: '30',
  Digits: '',
  CouponGoodsNo: '',
  CouponName: '',
  PreOrderDetailId: ''
}];

const orderNumListPattern02And03And06 = [{
  OrderNum: '111111',
  PCode: 'P1111111',
  GuideGoodsName: '商品1',
  GuideStandardName: '規格1',
  PageNum: '',
  OrderNumSeqNo: '',
  Digits: '6',
  CouponGoodsNo: '',
  CouponName: '',
  PreOrderDetailId: ''
}, {
  OrderNum: '222',
  PCode: 'P222222',
  GuideGoodsName: '商品2',
  GuideStandardName: '規格2',
  PageNum: '',
  OrderNumSeqNo: '',
  Digits: '3',
  CouponGoodsNo: '',
  CouponName: '',
  PreOrderDetailId: ''
}, {
  OrderNum: '',
  PCode: 'P3333333',
  GuideGoodsName: '商品3',
  GuideStandardName: '規格3',
  PageNum: '',
  OrderNumSeqNo: '',
  Digits: '',
  CouponGoodsNo: '',
  CouponName: '',
  PreOrderDetailId: ''
}];

const orderNumListPattern04 = [{
  OrderNum: '111111',
  PCode: 'P1111111',
  GuideGoodsName: '',
  GuideStandardName: '',
  PageNum: '',
  OrderNumSeqNo: '',
  Digits: '6',
  CouponGoodsNo: '11111111',
  CouponName: '商品単位値引クーポン1',
  CouponDiv: '1',
  PreOrderDetailId: ''
}, {
  OrderNum: '222222',
  PCode: 'P222222',
  GuideGoodsName: '',
  GuideStandardName: '',
  PageNum: '',
  OrderNumSeqNo: '',
  Digits: '6',
  CouponGoodsNo: '22222222',
  CouponName: '商品単位値引クーポン2',
  CouponDiv: '1',
  PreOrderDetailId: ''
}, {
  OrderNum: '',
  PCode: 'P3333333',
  GuideGoodsName: '',
  GuideStandardName: '',
  PageNum: '',
  OrderNumSeqNo: '',
  Digits: '',
  CouponGoodsNo: '33333333',
  CouponName: '商品単位値引クーポン3',
  CouponDiv: '1',
  PreOrderDetailId: ''
}, {
  OrderNum: '444444',
  PCode: '',
  GuideGoodsName: '',
  GuideStandardName: '',
  PageNum: '',
  OrderNumSeqNo: '',
  Digits: '6',
  CouponGoodsNo: '44444444',
  CouponName: '注文単位値引クーポン1',
  CouponDiv: '2',
  PreOrderDetailId: ''
}, {
  OrderNum: '555555',
  PCode: '',
  GuideGoodsName: '',
  GuideStandardName: '',
  PageNum: '',
  OrderNumSeqNo: '',
  Digits: '6',
  CouponGoodsNo: '55555555',
  CouponName: '注文単位値引クーポン2',
  CouponDiv: '2',
  PreOrderDetailId: ''
}, {
  OrderNum: '',
  PCode: '',
  GuideGoodsName: '',
  GuideStandardName: '',
  PageNum: '',
  OrderNumSeqNo: '',
  Digits: '',
  CouponGoodsNo: '66666666',
  CouponName: '注文単位値引クーポン3',
  CouponDiv: '2',
  PreOrderDetailId: ''
}];

const orderNumListPattern07And09 = [{
  OrderNum: '111111',
  PCode: 'P1111111',
  GuideGoodsName: '商品1',
  GuideStandardName: '',
  PageNum: '',
  OrderNumSeqNo: '',
  Digits: '6',
  CouponGoodsNo: '',
  CouponName: '',
  PreOrderDetailId: ''
}, {
  OrderNum: '222222',
  PCode: 'P222222',
  GuideGoodsName: '商品2',
  GuideStandardName: '',
  PageNum: '',
  OrderNumSeqNo: '',
  Digits: '6',
  CouponGoodsNo: '',
  CouponName: '',
  PreOrderDetailId: ''
}, {
  OrderNum: '',
  PCode: 'P3333333',
  GuideGoodsName: '商品3',
  GuideStandardName: '',
  PageNum: '',
  OrderNumSeqNo: '',
  Digits: '',
  CouponGoodsNo: '',
  CouponName: '',
  PreOrderDetailId: ''
}];

const orderNumListPattern08 = [{
  OrderNum: '111111',
  PCode: 'P1111111',
  GuideGoodsName: '商品1',
  GuideStandardName: '規格1',
  PageNum: '',
  OrderNumSeqNo: '',
  Digits: '6',
  CouponGoodsNo: '',
  CouponName: '',
  PreOrderDetailId: '11111111'
}, {
  OrderNum: '222222',
  PCode: 'P222222',
  GuideGoodsName: '商品2',
  GuideStandardName: '規格2',
  PageNum: '',
  OrderNumSeqNo: '',
  Digits: '6',
  CouponGoodsNo: '',
  CouponName: '',
  PreOrderDetailId: '22222222'
}, {
  OrderNum: '',
  PCode: 'P3333333',
  GuideGoodsName: '商品3',
  GuideStandardName: '規格3',
  PageNum: '',
  OrderNumSeqNo: '',
  Digits: '',
  CouponGoodsNo: '',
  CouponName: '',
  PreOrderDetailId: '3333333'
}];

const updateIndiscriminatelyOrderNumResponse = {
  "status": "ok",
  "message": "処理完了",
  "result": {
    "obj": [
      {
        "OrderNum": "104110",
        "PCode": "P2674641",
        "GuideGoodsName": "ブラックムーンガレットサンド",
        "GuideStandardName": "６個（個包装）",
        "PageNum": 501,
        "OrderNumSeqNo": 10,
        "Digits": 6,
        "CouponGoodsNo": "1234567890",
        "CouponName": "クーポン名１",
        "CouponDiv": "1",
        "PreOrderDetailId": "12345678",
        "ItemCode": "1234567",
        "NvalDetailId": "123456789",
        "OrderNumPreBundleDiffFlg": "0"
      },
      {
        "OrderNum": "104111",
        "PCode": "P2674656",
        "GuideGoodsName": "十六茶",
        "GuideStandardName": "６００ｍｌ",
        "PageNum": 501,
        "OrderNumSeqNo": 20,
        "Digits": 6,
        "CouponGoodsNo": "2345678901",
        "CouponName": "クーポン名２",
        "CouponDiv": "0",
        "PreOrderDetailId": "23456789",
        "ItemCode": "2345678",
        "NvalDetailId": "234567890",
        "OrderNumPreBundleDiffFlg": "1"
      },
      {
        "OrderNum": "104112",
        "PCode": "P2674657",
        "GuideGoodsName": "香るブレンドハーブティーｂｙ十六茶",
        "GuideStandardName": "６３０ｍｌ",
        "PageNum": 501,
        "OrderNumSeqNo": 20,
        "Digits": 6,
        "CouponGoodsNo": "3456789012",
        "CouponName": "クーポン名３",
        "CouponDiv": "0",
        "PreOrderDetailId": "34567890",
        "ItemCode": "3456789",
        "NvalDetailId": "345678901",
        "OrderNumPreBundleDiffFlg": "1"
      }
    ]
  }
}

const updateIndividuallyOrderNumResponse = {
  "status": "ok",
  "message": "処理完了",
  "result": {
    "obj": {
      "OrderNum": [
        "073004",
        "073010"
      ]
    }
  }
}